import { types, flow } from "mobx-state-tree";
import StatusCode from "../../utils/errorsCode";
import NotiService from "../../service/NotificationRequestServcice";
import { toJS } from "mobx";

const chartData = types.model({
    name: types.string,
    success: types.integer,
    error: types.integer,
})

export const RequestLogs = types.model({
    state: types.optional(types.enumeration(["running", "done", "init", "error"]), "init"),
    mainChartData: types.optional(types.array(chartData), []),
    iosChartData: types.optional(types.array(chartData), []),
    androidChartData: types.optional(types.array(chartData), []),
    webChartData: types.optional(types.array(chartData), []),
    otherChartData: types.optional(types.array(chartData), []),
    dataMKT: types.optional(types.array(chartData), []),
    getRequestLogsLoading: types.optional(types.boolean, false)
})
    .actions(self => ({
        getChartData: flow(function* (params = {}) {
            self.getRequestLogsLoading = true;
            self.state = "running";
            try {
                let res = yield NotiService.getDataChart(params)
                if (res.status) {
                    self.mainChartData = res.data
                    self.dataMKT = res.dataMKT
                    self.state = "done";
                }
            } catch (err) {
                let data = err.data;
                alert(StatusCode[data.error])
                self.state = "error";
            }
            self.getRequestLogsLoading = false
        }),
        getDataChartByPlatform: flow(function* (params = {}) {
            self.getRequestLogsLoading = true;
            self.state = "running";
            try {
                let res = yield NotiService.getDataChartByPlatform(params)
                if (res.status) {
                    // self.mainChartData = res.data
                    if (params.type === 'mkt') {
                        self.iosChartData = res.dataMKT.ios
                        self.androidChartData = res.dataMKT.android
                        self.webChartData = res.dataMKT.web
                        self.otherChartData = res.dataMKT.other
                    } else {
                        self.iosChartData = res.data.ios
                        self.androidChartData = res.data.android
                        self.webChartData = res.data.web
                        self.otherChartData = res.data.other
                    }
                    self.state = "done";
                }
            } catch (err) {
                if (typeof err === 'object') {
                    // let data = err.data;
                    // alert(StatusCode[data.error])
                    self.state = "error";
                } else {
                    // let data = {error: err};
                    // alert(data.error)
                    self.state = "error";
                }
            }
            self.getRequestLogsLoading = false
        }),
    }))
    .views(self => ({
        get getMainChartData() {
            return toJS(self.mainChartData)
        },
        get getDataMKT() {
            return toJS(self.dataMKT)
        },
        get getiosChartData() {
            return toJS(self.iosChartData)
        },
        get getAndroidChartData() {
            return toJS(self.androidChartData)
        },
        get getWebChartData() {
            return toJS(self.webChartData)
        },
        get getOtherChartData() {
            return toJS(self.otherChartData)
        }
    }))